"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableDataField = exports.SelectTypeDataField = exports.TextDataField = exports.NumDataField = exports.HeaderDataField = exports.ImageDataField = exports.DrawDataField = exports.DateDataField = exports.ChoiceDataField = exports.DataField = exports.DataFieldFactory = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactIntl = require("react-intl");

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _tcombForm = require("tcomb-form");

var form = _interopRequireWildcard(_tcombForm);

var _uuid = require("uuid");

var uuid = _interopRequireWildcard(_uuid);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var I18N_NEW_ITEM_STRING = "Neues Item";

var DataFieldFactory = exports.DataFieldFactory = function DataFieldFactory() {
    _classCallCheck(this, DataFieldFactory);
};

DataFieldFactory.emptyDataFieldWithType = function (type) {
    switch (type) {
        case "header":
            return HeaderDataField.createNew();
        case "date":
            return DateDataField.createNew();
        case "text":
            return TextDataField.createNew();
        case "num":
            return NumDataField.createNew();
        case "draw":
            return DrawDataField.createNew();
        case "choice":
            return ChoiceDataField.createNew();
        case "table":
            return TableDataField.createNew();
        case "selectType":
            return SelectTypeDataField.createNew();
        case "image":
            return ImageDataField.createNew();
    }
    ;
    return null;
};
DataFieldFactory.dataFieldForProps = function (props) {
    switch (props.type) {
        case "header":
            return HeaderDataField.createWithProps(props.properties);
        case "date":
            return DateDataField.createWithProps(props.properties);
        case "text":
            return TextDataField.createWithProps(props.properties);
        case "num":
            return NumDataField.createWithProps(props.properties);
        case "draw":
            return DrawDataField.createWithProps(props.properties);
        case "choice":
            return ChoiceDataField.createWithProps(props.properties);
        case "table":
            return TableDataField.createWithProps(props.properties);
        case "selectType":
            return SelectTypeDataField.createWithProps(props.properties);
        case "image":
            return ImageDataField.createWithProps(props.properties);
    }
    ;
    return null;
};

var DataField = exports.DataField = function () {
    function DataField(uid, title) {
        var description = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
        var notCopyByCopyFlag = arguments[3];
        var notCopyByUpgradeFlag = arguments[4];

        _classCallCheck(this, DataField);

        this.schema = DataField.Schema;
        this.uid = uid;
        this.title = title;
        this.description = description;
        this.notCopyByCopyFlag = notCopyByCopyFlag;
        this.notCopyByUpgradeFlag = notCopyByUpgradeFlag;
    }

    _createClass(DataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            return {
                fields: {
                    notCopyByCopyFlag: {
                        label: "Nicht mitkopieren beim Kopieren"
                    },
                    notCopyByUpgradeFlag: {
                        label: "Nicht mitkopieren beim Upgrade"
                    },
                    title: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.general.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.general.title.validationError" }))
                    },
                    description: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.general.description" })
                    },
                    uid: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.general.uid" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.general.uid.validationError" }))
                    }
                }
            };
        }
    }]);

    return DataField;
}();

DataField.Schema = t.struct({
    uid: t.refinement(t.String, function (s) {
        var isUid = s.match(/[a-z0-9-]{36}/) ? s.match(/[a-z0-9-]{36}/)[0].length === s.length : false;
        if (isUid) {
            return true;
        }
        return s.match(/[a-z0-9_]+[a-zA-Z0-9_]*/) ? s.match(/[a-z0-9_]+[a-zA-Z0-9_]*/)[0].length === s.length : false;
    }),
    title: t.String,
    description: t.maybe(t.String),
    notCopyByCopyFlag: t.maybe(t.Boolean),
    notCopyByUpgradeFlag: t.maybe(t.Boolean)
}, "DataFieldSchema");
DataField.createNew = function () {
    return new DataField(uuid.v4(), I18N_NEW_ITEM_STRING, null, false, false);
};
DataField.createWithProps = function (props) {
    // if (validation.validate(props, DataField.Schema).isValid()) {
    var dataField = new DataField(props.uid, props.title, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    dataField.props = props;
    return dataField;
    // }
    // return null;
};

var ChoiceDataField = exports.ChoiceDataField = function (_DataField) {
    _inherits(ChoiceDataField, _DataField);

    function ChoiceDataField(uid, title, isMandatory, isSingleChoice, choices, isFreetextAllowed) {
        var freetextMaxLength = arguments.length <= 6 || arguments[6] === undefined ? null : arguments[6];
        var description = arguments.length <= 7 || arguments[7] === undefined ? null : arguments[7];
        var notCopyByCopyFlag = arguments[8];
        var notCopyByUpgradeFlag = arguments[9];

        _classCallCheck(this, ChoiceDataField);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChoiceDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this.schema = ChoiceDataField.Schema;
        _this.isMandatory = isMandatory;
        _this.isSingleChoice = isSingleChoice;
        _this.isFreetextAllowed = isFreetextAllowed;
        _this.freetextMaxLength = freetextMaxLength;
        _this.choices = choices;
        return _this;
    }

    _createClass(ChoiceDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(ChoiceDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    isMandatory: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.choice.isMandatory.title" })
                    },
                    isSingleChoice: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.choice.isSingleChoice.title" })
                    },
                    choices: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.choice.choices.title" }),
                        disableOrder: true,
                        i18n: {
                            add: React.createElement("span", null, React.createElement("i", { className: "fa fa-plus" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "add" })),
                            remove: React.createElement("span", null, React.createElement("i", { className: "fa fa-remove" }))
                        }
                    },
                    isFreetextAllowed: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.choice.isFreetextAllowed.title" })
                    },
                    freetextMaxLength: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.text.maxLength.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.number.validationError" }))
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return ChoiceDataField;
}(DataField);

ChoiceDataField.Schema = DataField.Schema.extend({
    isMandatory: t.Boolean,
    isSingleChoice: t.Boolean,
    choices: t.list(t.String),
    isFreetextAllowed: t.Boolean,
    freetextMaxLength: t.maybe(t.Number)
}, "ChoiceDataFieldSchema");
ChoiceDataField.createNew = function () {
    return new ChoiceDataField(uuid.v4(), I18N_NEW_ITEM_STRING, false, true, [], false, null, null, false, false);
};
ChoiceDataField.createWithProps = function (props) {
    // if (validation.validate(props, ChoiceDataField.Schema).isValid()) {
    var dataField = new ChoiceDataField(props.uid, props.title, props.isMandatory, props.isSingleChoice, props.choices, props.isFreetextAllowed, props.freetextMaxLength, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    dataField.props = props;
    return dataField;
    // }
    // return null;
};

var DateDataField = exports.DateDataField = function (_DataField2) {
    _inherits(DateDataField, _DataField2);

    function DateDataField(uid, title, defaultValue, isMandatory) {
        var description = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
        var notCopyByCopyFlag = arguments[5];
        var notCopyByUpgradeFlag = arguments[6];

        _classCallCheck(this, DateDataField);

        var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(DateDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this2.schema = DateDataField.Schema;
        _this2.default = defaultValue;
        _this2.isMandatory = isMandatory;
        return _this2;
    }

    _createClass(DateDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(DateDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    default: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.date.default.title" })
                    },
                    isMandatory: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.date.isMandatory.title" })
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return DateDataField;
}(DataField);

DateDataField.Schema = DataField.Schema.extend({
    default: t.maybe(t.String),
    isMandatory: t.Boolean
}, "DateDataFieldSchema");
DateDataField.createNew = function () {
    return new DateDataField(uuid.v4(), I18N_NEW_ITEM_STRING, null, false, null, false, false);
};
DateDataField.createWithProps = function (props) {
    // if (validation.validate(props, DateDataField.Schema).isValid()) {
    var dateDataField = new DateDataField(props.uid, props.title, props.default, props.isMandatory, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    dateDataField.props = props;
    return dateDataField;
    // }
    // return null;
};

var DrawDataField = exports.DrawDataField = function (_DataField3) {
    _inherits(DrawDataField, _DataField3);

    function DrawDataField(uid, title, isSigning, isMandatory) {
        var description = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
        var notCopyByCopyFlag = arguments[5];
        var notCopyByUpgradeFlag = arguments[6];

        _classCallCheck(this, DrawDataField);

        var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(DrawDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this3.schema = DrawDataField.Schema;
        _this3.isMandatory = isMandatory;
        _this3.isSigning = isSigning;
        return _this3;
    }

    _createClass(DrawDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(DrawDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    isMandatory: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.draw.isMandatory.title" })
                    },
                    isSigning: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.draw.isSigning.title" })
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return DrawDataField;
}(DataField);

DrawDataField.Schema = DataField.Schema.extend({
    isSigning: t.Boolean,
    isMandatory: t.Boolean
}, "DrawDataFieldSchema");
DrawDataField.createNew = function () {
    return new DrawDataField(uuid.v4(), I18N_NEW_ITEM_STRING, false, false, null, false, false);
};
DrawDataField.createWithProps = function (props) {
    // if (validation.validate(props, DrawDataField.Schema).isValid()) {
    var drawDataField = new DrawDataField(props.uid, props.title, props.isSigning, props.isMandatory, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    drawDataField.props = props;
    return drawDataField;
    // }
    // return null;
};

var ImageDataField = exports.ImageDataField = function (_DataField4) {
    _inherits(ImageDataField, _DataField4);

    function ImageDataField(uid, title, isMandatory) {
        var description = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
        var notCopyByCopyFlag = arguments[4];
        var notCopyByUpgradeFlag = arguments[5];

        _classCallCheck(this, ImageDataField);

        var _this4 = _possibleConstructorReturn(this, Object.getPrototypeOf(ImageDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this4.schema = ImageDataField.Schema;
        _this4.isMandatory = isMandatory;
        return _this4;
    }

    _createClass(ImageDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(ImageDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    isMandatory: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.draw.isMandatory.title" })
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return ImageDataField;
}(DataField);

ImageDataField.Schema = DataField.Schema.extend({
    isMandatory: t.Boolean
}, "ImageDataFieldSchema");
ImageDataField.createNew = function () {
    return new ImageDataField(uuid.v4(), I18N_NEW_ITEM_STRING, false, null, false, false);
};
ImageDataField.createWithProps = function (props) {
    // if (validation.validate(props, DrawDataField.Schema).isValid()) {
    var drawDataField = new ImageDataField(props.uid, props.title, props.isMandatory, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    drawDataField.props = props;
    return drawDataField;
    // }
    // return null;
};

var HeaderDataField = exports.HeaderDataField = function (_DataField5) {
    _inherits(HeaderDataField, _DataField5);

    function HeaderDataField(uid, title) {
        var description = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
        var notCopyByCopyFlag = arguments[3];
        var notCopyByUpgradeFlag = arguments[4];

        _classCallCheck(this, HeaderDataField);

        var _this5 = _possibleConstructorReturn(this, Object.getPrototypeOf(HeaderDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this5.schema = HeaderDataField.Schema;
        return _this5;
    }

    return HeaderDataField;
}(DataField);

HeaderDataField.Schema = DataField.Schema.extend({}, "HeaderDataFieldSchema");
HeaderDataField.createNew = function () {
    return new HeaderDataField(uuid.v4(), I18N_NEW_ITEM_STRING, null, false, false);
};
HeaderDataField.createWithProps = function (props) {
    // if (validation.validate(props, HeaderDataField.Schema).isValid()) {
    var headerDataField = new HeaderDataField(props.uid, props.title, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    headerDataField.props = props;
    return headerDataField;
    // }
    // return null;
};

var NumDataField = exports.NumDataField = function (_DataField6) {
    _inherits(NumDataField, _DataField6);

    function NumDataField(uid, title, isMandatory) {
        var defaultValue = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
        var minValue = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
        var maxValue = arguments.length <= 5 || arguments[5] === undefined ? null : arguments[5];
        var unit = arguments.length <= 6 || arguments[6] === undefined ? null : arguments[6];
        var description = arguments.length <= 7 || arguments[7] === undefined ? null : arguments[7];
        var notCopyByCopyFlag = arguments[8];
        var notCopyByUpgradeFlag = arguments[9];

        _classCallCheck(this, NumDataField);

        var _this6 = _possibleConstructorReturn(this, Object.getPrototypeOf(NumDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this6.schema = NumDataField.Schema;
        _this6.isMandatory = isMandatory;
        _this6.default = defaultValue;
        _this6.minValue = minValue;
        _this6.maxValue = maxValue;
        _this6.unit = unit;
        return _this6;
    }

    _createClass(NumDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(NumDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    isMandatory: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.num.isMandatory.title" })
                    },
                    default: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.num.default.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.number.validationError" }))
                    },
                    minValue: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.num.minValue.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.number.validationError" }))
                    },
                    maxValue: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.num.maxValue.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.number.validationError" }))
                    },
                    unit: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.num.unit.title" })
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return NumDataField;
}(DataField);

NumDataField.Schema = DataField.Schema.extend({
    default: t.maybe(t.Number),
    isMandatory: t.Boolean,
    minValue: t.maybe(t.Number),
    maxValue: t.maybe(t.Number),
    unit: t.maybe(t.String)
}, "NumDataFieldSchema");
NumDataField.createNew = function () {
    return new NumDataField(uuid.v4(), I18N_NEW_ITEM_STRING, false, null, null, null, null, null, false, false);
};
NumDataField.createWithProps = function (props) {
    // if (validation.validate(props, NumDataField.Schema).isValid()) {
    var numDataField = new NumDataField(props.uid, props.title, props.isMandatory, props.default, props.minValue, props.maxValue, props.unit, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    numDataField.props = props;
    return numDataField;
    // }
    // return null;
};

var TextDataField = exports.TextDataField = function (_DataField7) {
    _inherits(TextDataField, _DataField7);

    function TextDataField(uid, title, isMandatory) {
        var defaultValue = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
        var maxLength = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
        var description = arguments.length <= 5 || arguments[5] === undefined ? null : arguments[5];
        var notCopyByCopyFlag = arguments[6];
        var notCopyByUpgradeFlag = arguments[7];

        _classCallCheck(this, TextDataField);

        var _this7 = _possibleConstructorReturn(this, Object.getPrototypeOf(TextDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this7.schema = TextDataField.Schema;
        _this7.isMandatory = isMandatory;
        _this7.default = defaultValue;
        _this7.maxLength = maxLength;
        return _this7;
    }

    _createClass(TextDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(TextDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    isMandatory: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.text.isMandatory.title" })
                    },
                    default: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.text.default.title" })
                    },
                    maxLength: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.text.maxLength.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.number.validationError" }))
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return TextDataField;
}(DataField);

TextDataField.Schema = DataField.Schema.extend({
    default: t.maybe(t.String),
    isMandatory: t.Boolean,
    maxLength: t.maybe(t.Number)
}, "TextDataFieldSchema");
TextDataField.createNew = function () {
    return new TextDataField(uuid.v4(), I18N_NEW_ITEM_STRING, false, null, null, null, false, false);
};
TextDataField.createWithProps = function (props) {
    // if (validation.validate(props, TextDataField.Schema).isValid()) {
    var textDataField = new TextDataField(props.uid, props.title, props.isMandatory, props.default, props.maxLength, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    textDataField.props = props;
    return textDataField;
    // }
    // return null;
};

var SelectTypeDataField = exports.SelectTypeDataField = function (_DataField8) {
    _inherits(SelectTypeDataField, _DataField8);

    function SelectTypeDataField(uid, title, isMandatory, refUid) {
        var description = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
        var notCopyByCopyFlag = arguments[5];
        var notCopyByUpgradeFlag = arguments[6];

        _classCallCheck(this, SelectTypeDataField);

        var _this8 = _possibleConstructorReturn(this, Object.getPrototypeOf(SelectTypeDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this8.schema = SelectTypeDataField.Schema;
        _this8.isMandatory = isMandatory;
        _this8.refUid = refUid;
        return _this8;
    }

    _createClass(SelectTypeDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(SelectTypeDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    isMandatory: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.selectType.isMandatory.title" })
                    },
                    refUid: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.selectType.refUid.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.selectType.refUid.validationError" })),
                        options: options,
                        factory: form.form.Select
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return SelectTypeDataField;
}(DataField);

SelectTypeDataField.Schema = DataField.Schema.extend({
    refUid: t.String,
    isMandatory: t.Boolean
}, "SelectTypeDataField");
SelectTypeDataField.createNew = function () {
    return new SelectTypeDataField(uuid.v4(), I18N_NEW_ITEM_STRING, false, "", null, false, false);
};
SelectTypeDataField.createWithProps = function (props) {
    // if (validation.validate(props, SelectTypeDataField.Schema).isValid()) {
    var selectTypeDataField = new SelectTypeDataField(props.uid, props.title, props.isMandatory, props.refUid, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    selectTypeDataField.props = props;
    return selectTypeDataField;
    // }
    // return null;
};

var TableDataField = exports.TableDataField = function (_DataField9) {
    _inherits(TableDataField, _DataField9);

    function TableDataField(uid, title, refUid, minMaxFieldUid) {
        var description = arguments.length <= 4 || arguments[4] === undefined ? null : arguments[4];
        var notCopyByCopyFlag = arguments[5];
        var notCopyByUpgradeFlag = arguments[6];

        _classCallCheck(this, TableDataField);

        var _this9 = _possibleConstructorReturn(this, Object.getPrototypeOf(TableDataField).call(this, uid, title, description, notCopyByCopyFlag, notCopyByUpgradeFlag));

        _this9.schema = TableDataField.Schema;
        _this9.refUid = refUid;
        _this9.minMaxFieldUid = minMaxFieldUid;
        return _this9;
    }

    _createClass(TableDataField, [{
        key: "schemaOptions",
        value: function schemaOptions(formattedMessage, options, tableItems) {
            var baseOptions = _get(Object.getPrototypeOf(TableDataField.prototype), "schemaOptions", this).call(this, formattedMessage, options, tableItems);
            var schemaOptions = {
                fields: {
                    minMaxFieldUid: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.table.minMaxFieldUid.title" }),
                        options: tableItems,
                        factory: form.form.Select
                    },
                    refUid: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.table.refUid.title" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "designer.datafield.table.refUid.validationError" })),
                        options: options,
                        factory: form.form.Select
                    }
                }
            };
            return { fields: Object.assign(schemaOptions.fields, baseOptions.fields) };
        }
    }]);

    return TableDataField;
}(DataField);

TableDataField.Schema = DataField.Schema.extend({
    refUid: t.String,
    minMaxFieldUid: t.maybe(t.String)
}, "TableDataField");
TableDataField.createNew = function () {
    return new TableDataField(uuid.v4(), I18N_NEW_ITEM_STRING, "", "", null, false, false);
};
TableDataField.createWithProps = function (props) {
    // if (validation.validate(props, TableDataField.Schema).isValid()) {
    var tableDataField = new TableDataField(props.uid, props.title, props.refUid, props.minMaxFieldUid, props.description, props.notCopyByCopyFlag, props.notCopyByUpgradeFlag);
    tableDataField.props = props;
    return tableDataField;
    // }
    // return null;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/cms/reducers/designer/CMSReport/DataField.tsx
 ** module id = 333
 ** module chunks = 0
 **/